import { CabinCode } from "./types";

export const cabinMap: Record<CabinCode, string> = {
  E: "Economy",
  PE: "Premium Economy",
  B: "Business",
  F: "First Class",
};

export const corporateFareTypes = [
  "SME FARE",
  "CORPORATE SELECT",
  "SPECIAL CRP",
  "CP|CORPORATE FARES",
  "CORPORATE VALUE CLASS",
  "CORPORATE",
  "Lower cancellation charges",
  "CORPORATE FARES",
];
